
<section class="NotFoundView hero is-fullheight is-bold">
  <div class="hero-body">
    <div class="container">
      <div class="columns is-vcentered">
        <div class="column is-4 is-offset-4">
          <h1 class="title has-text-centered">
            Brak strony
          </h1>
          <router-link :to="{ name: 'login' }" class="navbar-item">
            Login
          </router-link>
        </div>
      </div>
    </div>
  </div>
</section>
